import { CSSObject } from '@emotion/react';

export const ButtonIncrease: CSSObject = {
  fontSize: ['xs', 'sm'],
};
